<div id="music-menu-container"
     *ngIf="hymnSelectionService.selectedHymn.hasMidi || midiPlayerService.playing">
  <div class="music-menu" *ngIf="musicToggle">

    <button #transposeTrigger="matMenuTrigger" mat-icon-button [matMenuTriggerFor]="transposeMenu">
      <mat-icon *ngIf="midiPlayerService.getTranspose() === 0" svgIcon="sharp"></mat-icon>
      <div *ngIf="midiPlayerService.getTranspose() !== 0" style="font-size: 0.9rem!important;">{{ formatTranspose(midiPlayerService.getTranspose()) }}</div>
    </button>

    <button mat-icon-button [matMenuTriggerFor]="speedMenu">
      <mat-icon *ngIf="midiPlayerService.playbackSpeed === 1.0">speed</mat-icon>
      <div *ngIf="midiPlayerService.playbackSpeed !== 1.0" style="font-size: 0.9rem!important;">{{midiPlayerService.playbackSpeed.toFixed(1)}}X</div>
    </button>

    <button mat-icon-button [matMenuTriggerFor]="instrumentMenu">
      <mat-icon svgIcon="guitar"></mat-icon>
    </button>

    <button *ngIf="!continuousPlaybackService.active && mode != 'presentation'" mat-icon-button (click)="autoScrollService.enabled? disableAutoScroll() : startAutoScroll()">
      <mat-icon *ngIf="autoScrollService.enabled">navigation</mat-icon>
      <mat-icon *ngIf="!autoScrollService.enabled">pan_tool</mat-icon>
    </button>

    <button *ngIf="midiPlayerService.playing" mat-icon-button (click)="midiPlayerService.stop()">
      <mat-icon>stop</mat-icon>
    </button>
    <button *ngIf="!midiPlayerService.playing" mat-icon-button (click)="playMidi()" [disabled]="hymnSelectionService.selectedHymn == null || !hymnSelectionService.selectedHymn.hasMidi">
      <mat-icon>play_arrow</mat-icon>
    </button>
    <button *ngIf="continuousPlaybackService.active" mat-icon-button (click)="continuousPlaybackService.next()">
      <mat-icon>skip_next</mat-icon>
    </button>

    <mat-menu #instrumentMenu="matMenu" yPosition="above">
      <ng-template matMenuContent>
        <h3 class="menu-heading">{{translation.instruments}}</h3>
        <div style="padding: 8px 16px; display: flex; flex-direction: column; gap: 12px; min-width: 240px;"
             (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()" (touchstart)="$event.stopPropagation()">
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>{{translation.instrument.lead}}</mat-label>
            <mat-select [value]="instrument1.key" (selectionChange)="onInstrument1Change($event.value)">
              <mat-option [value]="'random'">{{translation.instrument.random}}</mat-option>
              <mat-option class="clip" *ngFor="let instrument of instruments" [value]="instrument.key">{{instrument.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>{{translation.instrument.accompaniment}}</mat-label>
            <mat-select [value]="instrument2?.key || null" (selectionChange)="onInstrument2Change($event.value)">
              <mat-option [value]="null">{{translation.instrument.none}}</mat-option>
              <ng-container *ngFor="let instrument of instruments">
                <mat-option class="clip" *ngIf="instrument.key !== instrument1.key" [value]="instrument.key">{{instrument.name}}</mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-template>
    </mat-menu>
    <mat-menu #speedMenu="matMenu" yPosition="above">
      <button mat-menu-item (click)="changeSpeed($event, true)"
              (mousedown)="midiPlayerService.startSpeedChangeInterval(true)" (mouseup)="midiPlayerService.stopSpeedChangeInterval()" (mouseleave)="midiPlayerService.stopSpeedChangeInterval()"
              (touchstart)="midiPlayerService.startSpeedChangeInterval(true)" (touchend)="midiPlayerService.stopSpeedChangeInterval()" (touchcancel)="midiPlayerService.stopSpeedChangeInterval()"
      > <mat-icon>add</mat-icon> {{translation.faster_tempo}}</button>
      <button mat-menu-item (click)="changeSpeed($event, false)"
              (mousedown)="midiPlayerService.startSpeedChangeInterval(false)" (mouseup)="midiPlayerService.stopSpeedChangeInterval()" (mouseleave)="midiPlayerService.stopSpeedChangeInterval()"
              (touchstart)="midiPlayerService.startSpeedChangeInterval(false)" (touchend)="midiPlayerService.stopSpeedChangeInterval()" (touchcancel)="midiPlayerService.stopSpeedChangeInterval()"
      ><mat-icon>remove</mat-icon> {{translation.slower_tempo}}</button>
      <button mat-menu-item (click)="midiPlayerService.setPlaybackSpeed(1)">
        <mat-icon>restore</mat-icon> {{translation.reset_tempo}}</button>
    </mat-menu>

    <mat-menu #transposeMenu="matMenu" yPosition="above">
      <h3 class="menu-heading">{{translation.transpose}}</h3>
      <button mat-menu-item (click)="changeTranspose($event, 1)"><mat-icon>arrow_upward</mat-icon> {{translation.increase_key_one}}</button>
      <button mat-menu-item (click)="changeTranspose($event, -1)"><mat-icon>arrow_downward</mat-icon> {{translation.decrease_key_one}}</button>
      <button mat-menu-item (click)="resetTranspose($event)"><mat-icon>restore</mat-icon> {{translation.reset_transpose}}</button>
    </mat-menu>
  </div>

<!--  <button id="music-control-button" mat-fab color="primary" (click)="musicToggle = !musicToggle">-->
<!--    <mat-icon *ngIf="!musicToggle && !continuousPlaybackService.active">music_note</mat-icon>-->
<!--    <mat-icon *ngIf="!musicToggle && continuousPlaybackService.active">queue_music</mat-icon>-->
<!--    <mat-icon *ngIf="musicToggle">close</mat-icon>-->
<!--  </button>-->

  <div id="progress-circle-container">
    <div class="circle">
      <button id="music-control-button" mat-fab color="primary" (click)="toggleMusicMenu()">
        <mat-icon *ngIf="!musicToggle && !continuousPlaybackService.active">music_note</mat-icon>
        <mat-icon *ngIf="!musicToggle && continuousPlaybackService.active">queue_music</mat-icon>
        <mat-icon *ngIf="musicToggle">close</mat-icon>
      </button>
    </div>
  </div>
</div>
